<template lang="pug">
span.root
  slot(name="default", :tags="tags", :removeTag="removeTag", :clearAllTags="clearAllTags")
    .search__tags(v-if="tags.length")
      template(v-for="tag in tags")
        slot(name="item", :tag="tag", :removeTag="removeTag")
          Item(:tag="tag", :removeTag="removeTag")
</template>

<script>
import Item from "./Item.vue";
export default {
  name: "BlueTags",
  components: { Item },
  computed: {
    tags() {
      const recurse = (filters) => {
        const tags = []
        filters.forEach((f) => {
          if (f.selected) {
            tags.push(f);
          }
          if (f.filters) {
            let _tags = recurse(f.filters);
            if (_tags.length) {
              tags.push(..._tags);
            }
          }
        });
        return tags;
      }
      return this.$store.getters.results.filters.reduce((_tags, g) => {
        const tags = recurse(g.filters);
        _tags.push(...tags);
        return _tags;
      }, []);
    },
  },
  methods: {
    clearAllTags() {
      this.$store.dispatch("removeAllTags");
    },
    removeTag(tag) {
      this.$store.dispatch("removeTagItem", tag);
    },
  },
};
</script>

<style lang="scss" scoped>
span.root {
  display: contents;
}
.search__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 0;
}
</style>